import { printTimePeriod } from '@/helpers/dateHelper';
import { SeverityType } from '@/services/warnings/warningDefinitions';
import { RosterWarningModel, WarningsProps } from '../../../pages/roster/warnings/warnings.types';

export const getNobodyRosteredWarnings = (props: WarningsProps): RosterWarningModel[] => {
  const { strings, workingRoster } = props;

  const shiftWarnings: RosterWarningModel[] = [];

  workingRoster.shifts.forEach(shift => {
    if (!shift.assignedEmployeeId) {
      shiftWarnings.push({
        severity: SeverityType.WARNING,
        name: strings.nobodyRostered(printTimePeriod(shift.start!, shift.end!)),
        shiftId: shift.id
      });
    }
  });

  return shiftWarnings;
};
